import styled from 'styled-components';
import { baseTheme } from '../../../../global/styles/theme';

export const ApplyRecipeInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ApplyRecipeInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  width: 50%;

  .provision-status {
    height: 30px;
    p {
      margin: 0;
      font-size: 20px;
    }
  }
`;

export const ApplyProductsButton = styled.button`
  cursor: pointer;
  height: 40px;
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: ${baseTheme.colors.mainLightBlue};
  border-radius: 8px;
  border: none;
  font-size: 14px;
  padding: '0px 10px';
  color: ${baseTheme.colors.white};
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
